import {alarmSoundState} from '../state/alarmSoundState';
import {Fetch_Alarm_Sound_Data,Update_Alarm_Sound_Success, GET_ALARM_SOUND_REQUEST} from '../action/alarmSoundAction';

export function AlarmSoundReducer(state = alarmSoundState, action) {
    switch(action.type){
        case GET_ALARM_SOUND_REQUEST:
            return Object.assign({}, state, {
                errorCode : 0,
                statusCode : 0,
                message: '',
                isLoading : action.isLoading
            })
        case Fetch_Alarm_Sound_Data:
            return Object.assign({}, state, {
                isLoading : action.isLoading,
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                alarmSoundList : action.alarmSoundList
            })
        case Update_Alarm_Sound_Success:
            return Object.assign({}, state, {
                isLoading : action.isLoading,
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message: action.message,
                updatedValue : action.value
            })
        default:
            return state
    }
}